module.exports = __webpack_public_path__ + "img/curved1.9c80c846.jpg";